export class FullAddress {
	address1: string;
	address2: string;
	addressBookGroup: string;
	barcode: string;
	city: string;
	contact: string;
	country: any;
	destComments: string;
	lat: any;
	lon: any;
	modifiable: boolean;
	name: string;
	nonUsAddress: number;
	originComments: string;
	phone: string;
	phoneAsList: any;
	plus4: string;
  postalCode: string;
	id: number;
	state: string;
	userId: any;
	validated: number;
	zip: string;
	bypassValidation: boolean;
	canAccessAddress: boolean;
}
